@if (paginationData && paginationData.totalPages > 1) {
  <nav class="text-center" role="navigation" aria-label="Pagination">
    <ul class="pagination">
      @if (paginationData.previousPage && paginationData.totalPages > 2) {
        <li>
          <a href="#" (click)="onPageClick($event, 1)" aria-label="Goto First Page">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
      }
      @if (paginationData.previousPage) {
        <li>
          <a href="#" (click)="onPageClick($event, paginationData.previousPage)" aria-label="Goto Previous Page">
            <span aria-hidden="true">&lsaquo;</span>
          </a>
        </li>
      }
      @for (pageNumber of paginationData.paginationNumbers; track pageNumber) {
        <li [ngClass]="{active: paginationData.currentPage === pageNumber}">
          @if (paginationData.currentPage !== pageNumber) {
            <a href="#" (click)="onPageClick($event, pageNumber)" [attr.aria-label]="'Goto Page ' + pageNumber">{{pageNumber}}</a>
          }
          @if (paginationData.currentPage === pageNumber) {
            <a href="#" (click)="onPageClick($event, pageNumber)" [attr.aria-label]="'Page ' + pageNumber + ', Current page'" aria-current="true">{{pageNumber}}</a>
          }
        </li>
      }
      @if (paginationData.nextPage) {
        <li>
          <a href="#" (click)="onPageClick($event, paginationData.nextPage)" aria-label="Goto Next Page">
            <span aria-hidden="true">&rsaquo;</span>
          </a>
        </li>
      }
      @if (paginationData.nextPage && paginationData.totalPages > 2) {
        <li>
          <a href="#" (click)="onPageClick($event, paginationData.totalPages)" aria-label="Goto Last Page">
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      }
    </ul>
  </nav>
}
